var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isOnline)?_c('div',{staticClass:"connection-notice"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" You are offline, you will not be able to save data until you come back online.\n")]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a82ab1de","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ConnectionComponent.vue
// module id = bPWo
// module chunks = 0